import React from 'react'
import { SUBJECT_DETAIL } from '../urls'
import { usePutRequest } from '../hooks/request'
import SubjectForm from './SubjectForm'

export default function SubjectUpdate({ onSuccess, onCancel, room }) {
    const roomUpdate = usePutRequest({ url: SUBJECT_DETAIL.replace('{id}', room.id) })

    async function onSubmit(data, actions) {
        await roomUpdate.request({ data })
        actions.resetForm()
        onSuccess()
    }

    return (
        <div>
            <SubjectForm
                loading={roomUpdate.loading}
                onCancel={onCancel}
                initialValues={room}
                onSuccess={onSuccess}
                onSubmit={onSubmit} />
        </div>
    )
}
